import { useEffect } from 'react';
import { useParams } from 'react-router';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import LabOrderDetailsNav from '../components/LabOrderDetails/LabOrderDetailsNav';
import LabOrderDetailsInformation from '../components/LabOrderDetails/LabOrderDetailsInformation';
import { useLabOrderDetailsStore } from '../stores/index.js';

const LabOrderDetailsPage = () => {
  const { id: currentOrderId } = useParams();
  const { 
    orderLoading, 
    error, 
    getOrder, 
  } = useLabOrderDetailsStore();

  useEffect(() => {
    if (currentOrderId) {
      getOrder(currentOrderId);
    }
  }, [currentOrderId]); 

  if (error) return <ErrorMessage errors={error} />;

  return (
    <div className="container-orders">
      {orderLoading && <Loading message="Loading order..." />}

      {!orderLoading && (
        <div className="sub-container-orders lab-order-details-page">
          <LabOrderDetailsNav currentOrderId={currentOrderId}/>
          <LabOrderDetailsInformation />
        </div>
      )}
    </div>
  );
};

export default LabOrderDetailsPage;
